import React from 'react';

const TermsAndConditionsContent = () => {
  return (
    <>
      <h2>Welcome to Oasis Living</h2>
      <p>
        Regents Partners Ltd., registered in England and Wales with Company
        number 08271418 (“we”, “our”, or “us”) operates a platform which enables
        individuals (“Guests” or “you”) to view and make reservations for short,
        mid and long term rental properties listed on our website (each, a
        “Listing”) using our website at oasis-living.org (the “Service”).
      </p>
      <p>
        We operate the Service under the brand “Oasis Living”, a Regents
        Partners Ltd. owned brand. This Agreement is a legally binding contract
        between you and us regarding your use of the Service and Properties.
        Failure to use the Service or Properties in accordance with this
        Agreement may subject you to civil and criminal penalties.
      </p>
      <h3>PLEASE READ THE FOLLOWING TERMS AND CONDITIONS CAREFULLY</h3>
      <p>
        BY CLICKING “I ACCEPT” (OR WORDS TO SIMILAR EFFECT) OR BY DOWNLOADING,
        INSTALLING, OR OTHERWISE ACCESSING OR USING THE SERVICE OR PROPERTIES,
        YOU AGREE THAT YOU HAVE READ AND UNDERSTOOD, AND, AS A CONDITION TO YOUR
        USE OF THE SERVICE OR PROPERTIES, YOU AGREE TO BE BOUND BY, THIS
        AGREEMENT. IF YOU ARE NOT ELIGIBLE, OR DO NOT AGREE TO BE BOUND BY THIS
        AGREEMENT, THEN YOU DO NOT HAVE OUR PERMISSION TO USE THE SERVICE OR
        PROPERTIES. YOUR USE OF THE SERVICE OR PROPERTIES, AND OUR PROVISION OF
        THE SERVICE TO YOU AND EXPRESS LICENSE FOR YOU TO USE THE PROPERTIES (IF
        APPLICABLE), CONSTITUTE AN AGREEMENT BETWEEN US AND YOU TO BE BOUND BY
        THIS AGREEMENT.
      </p>
      <p>
        THIS AGREEMENT, WHETHER IN WHOLE OR PART, IS NOT A LEASE OR RESIDENTIAL
        TENANCY AGREEMENT, AND DOES NOT CONVEY OR OTHERWISE TRANSFER OR PROVIDE
        ANY PROPERTY, LEGAL, OR BENEFICIAL RIGHTS OR INTEREST IN REAL ESTATE TO
        YOU. YOU ARE NOT A TENANT OF, AND HAVE NOT BEEN GRANTED EXCLUSIVE
        POSSESSION OF, ANY OF THE PROPERTIES.
      </p>
      <ol>
        <li>
          <strong>Service Overview.</strong> We provide information on physical
          properties managed, owned, licensed, leased, rented, and/or developed
          by us or any of our affiliates (each a “Property” and collectively the
          “Properties”). You may use the Service to make legitimate reservations
          for certain Properties for short-term, mid-term or longer-term rentals
          and to obtain from us our express (i.e., written) permission for you
          to use such Properties for a certain period of time, in all cases,
          only in accordance with the terms and conditions of this Agreement.
          The “Service” excludes any and all Properties, but includes services
          provided by us to you in connection with your permitted use of the
          Properties (if applicable), whether you reserve such Properties
          directly from us or a third party.
        </li>
        <li>
          <strong>Eligibility.</strong> You must be at least 18 years old to use
          the Service. By agreeing to this Agreement, you represent and warrant
          to us that: (a) you are (i) at least 18 years old, are an emancipated
          minor, or possess legal parental or guardian consent to agree to this
          Agreement; and (ii) fully able and competent to enter into this
          Agreement; (b) you have not previously been suspended or removed from
          the Service or any of our Properties; and (c) your registration and
          your use of the Service and our Properties is and will be in
          compliance with any and all applicable laws, rules, and regulations.
          If you are an organization (e.g., a company or school), the individual
          accepting this Agreement on your behalf represents and warrants that
          he or she has the authority to bind you to this Agreement and you
          agree to be bound by this Agreement.
        </li>
        <li>
          <strong>Accounts and Registration.</strong> To access most features of
          the Service, you must register for an account. When you register for
          an account, you may be required to provide us with some information
          about yourself, such as your name, email address, home address, date
          of birth, and other contact information. You agree that the
          information you provide to us is accurate and that you will keep it
          accurate and up-to-date at all times. When you register, you will be
          asked to provide a password. You are solely responsible for
          maintaining the confidentiality of your account and password, and you
          accept responsibility for all activities that occur under your
          account. If you believe that your account is no longer secure, then
          you must immediately notify us at
          <a href="mailto:info@oasis-living.org">info@oasis-living.org</a>.
        </li>
        <li>
          <strong>Background Checks.</strong> You acknowledge and agree that for
          transparency, safety, and fraud prevention purposes, and to the extent
          permitted by applicable law, we may, but have no obligation to, before
          and/or while you reserve and/or occupy a Property:
          <div className="ml-5">
            a. require that you provide us with a form of government
            identification or other information sufficient to assist us with
            undertaking the background checks described in Sections 4(b)-(c);
          </div>
          <div className="ml-5">
            b. screen you against third party databases or other sources and
            request reports (e.g., credit checks) regarding you from service
            providers (if available); and
          </div>
          <div className="ml-5">
            c. for users outside of the UK and EU, obtain reports from public
            records of criminal convictions or sex offender registrations or an
            equivalent version of background or registered sex offender checks
            (if available). You hereby consent to our undertaking the foregoing
            background checks and to our processing of the resulting information
            in accordance with our Privacy Policy (if applicable), including
            sharing with landlords and/or their property managers (collectively,
            “Landlords”) the results of background checks for users based in the
            U.S.
          </div>
        </li>

        <li>
          <strong>Fees and Payment.</strong> Certain features of the Service may
          require you to pay fees. Before you pay any fees, you will have an
          opportunity to review and accept the fees that you will be charged.-
          NEED TO CLARIFY WHETHER THIS IS HOW OUR PAYMENT SYSTEM WORKS All (SAM)
          fees are non-refundable, unless expressly provided otherwise in
          writing by us.
          <ol>
            <li>
              <strong>Fees.</strong> We reserve the right to determine pricing
              for the Service and any products we offer for sale or Properties
              that you may reserve through the Service. We will make reasonable
              efforts to keep pricing information published on our website up to
              date. We encourage you to check our website periodically for
              current pricing information. We may change any of this pricing
              information (including by adding applicable fees or charges) at
              any time prior to your completing a reservation and will give you
              notice of the applicable pricing information prior to completion
              of such reservation. We, in our sole discretion, may make
              promotional offers with different features and different pricing
              to any of our customers. These promotional offers, unless made to
              you, will not apply to you or this Agreement
            </li>
            <li>
              <strong>Currency.</strong> If you request a reservation, you will
              be notified of the currency in which you will be charged. This
              currency will be determined by us based on the Applicable Payment
              Method (defined in Section 5.3) and the location of the Property
              that you are reserving. For your convenience and if the currency
              you will be charged in is not the same as the currency applicable
              in your country, we may provide you with an indication of how much
              the price would approximately be in your own currency. Such
              indication is merely indicative, not binding, and will depend on
              the applicable exchange rate of the day. You acknowledge that the
              applicable exchange rate used for currency conversion processing
              may not be identical to the applicable market rate in effect at
              the specific time such processing occurs because: (i) we update
              the applicable exchange rate on a regular, but not real-time,
              basis; and (ii) the applicable exchange rate may include an
              incremental cost or margin that is not included in the applicable
              market rate.
            </li>
            <li>
              <strong>
                Authorization. You authorize us to charge all applicable sums
                (including any applicable security deposits and cleaning fees)
                for the reservations and/or purchases that you make through the
                Service and, in accordance with Section 7.5, for the Damaged
                Property Fee (defined in Section 7.5), including all applicable
                taxes, to the payment method specified in your account or that
                you otherwise indicate when you submit such reservation and/or
                purchase order to us (the “Applicable Payment Method”).
              </strong>
              Additionally, if the Applicable Payment Method is a credit card,
              then: (a) we may seek pre-authorization of your credit card
              account prior to your reservation or purchase to verify that the
              credit card is valid and has the necessary funds or credit
              available to cover your reservation or purchase, or any potential
              Damaged Property Fee that may apply; and (b) you authorize us to
              place a hold on such credit card for sums sufficient to cover any
              applicable Damaged Property Fee and any other fees that you owe us
              under this Agreement.
            </li>
            <li>
              <strong>Cancellations and modifications</strong> You may modify or
              cancel a Booking through the Service or by contacting us at
              <a href="mailto:info@oasis-living.org">info@oasis-living.org</a>.
              Any modification or cancellation may be subject to additional
              terms and conditions as notified to you prior to your confirmation
              of a request to modify or cancel a Booking, including the terms
              and conditions set out in this clause. If you cancel a Booking,
              the following amounts of the Booking Fee will be refunded to you:
              <ol>
                <li>
                  If you cancel a Booking, the following amounts of the Booking
                  Fee will be refunded to you:
                  <ol>
                    <li>
                      if you cancel your Booking within 48 hours of making the
                      Booking, and at least thirty (30) days before the first
                      day of your reservation, you will receive a full refund of
                      the Booking Fee;
                    </li>
                    <li>
                      if you cancel your Booking between thirty (30) days and
                      one (1) week before the first day of your reservation, you
                      will receive a refund of 50% of the Booking Fee;
                    </li>
                    <li>
                      if you cancel your Booking during the week before the
                      first day of your reservation, you will not receive any
                      refund of the Booking Fee;
                    </li>
                    <li>
                      if you cancel your Booking during the reservation period
                      (for example, if you want to check out before the agreed
                      check-out date), you will not receive any refund of the
                      Booking Fee;
                    </li>
                  </ol>
                  <li>
                    if your reservation is for a period of thirty (30) days or
                    more:
                    <ol>
                      <li>
                        if you cancel your Booking at least twenty-nine (29)
                        days before the first day of your reservation, you will
                        receive a refund of the Booking Fee less the fees for
                        the first month of the reservation;
                      </li>
                      <li>
                        if you cancel your Booking during the period of
                        twenty-eight (28) days before the first day of your
                        reservation, you will not receive any refund of the
                        Booking Fee; and
                      </li>
                      <li>
                        if you cancel your Booking during the reservation period
                        (for example, if you want to check out before the agreed
                        check-out date), you will receive a refund of the
                        Booking Fee for any amounts paid in advance in respect
                        of the period commencing thirty (30) days after the date
                        of cancellation. In other words, you will not receive a
                        refund for the period prior to the date of cancellation,
                        and you will not receive a refund (or you will be
                        required to pay, if you have not already done so) the
                        fee for the period of thirty (30) days after the date of
                        cancellation (or for the remainder of your reservation,
                        if this is less than thirty (30) days).
                      </li>
                    </ol>
                    <li>
                      If you check out three (3) or more hours after the
                      check-out time [as notified to you on the Booking
                      confirmation], you will be charged for one (1) additional
                      night for late check-out, as notified to you [on the
                      reservation confirmation email]. This additional fee will
                      be calculated at the same daily rate.
                    </li>
                  </li>
                </li>
              </ol>
            </li>
          </ol>
        </li>
        <li>
          <strong>Service and Booked Properties.</strong>
          <ol>
            <li>
              <strong>
                Limited License to the Service. Subject to your complete and
                ongoing compliance with this Agreement, we grant you, solely for
                your personal and non-commercial use (except as expressly
                provided in this Section 6.1), a limited, non-exclusive,
                non-transferable, non-sublicensable, revocable license to access
                and use the Service. Notwithstanding the foregoing, you may use
                the Service for non-personal and/or commercial use only if you
                are an organization and only to reserve Properties for or on
                behalf of your organization’s employees, your organization’s
                students, and/or a third party (“Limited Commercial Use”),
                provided that:
              </strong>
              <ol>
                <li>
                  <strong>
                    you enter into a separate written agreement with us that
                    provides additional terms and conditions governing this
                    Limited Commercial Use (“Commercial Agreement”)
                  </strong>
                  and such use shall be subject to the terms and conditions of
                  this Agreement and the Commercial Agreement;
                </li>
                <li>
                  you require each employee, student, and/or third party to
                  agree in writing to be bound by this Agreement; and
                </li>
                <li>
                  you remain responsible and liable for all acts and omissions
                  of each such employee, student, and/or third party to the same
                  extent as if such acts and omissions had been undertaken by
                  you.
                </li>
              </ol>
            </li>
            <li>
              Limited License to Booked Properties. Subject to your complete and
              ongoing compliance with this Agreement, we grant you a limited,
              exclusive (except as expressly provided in this Section 6.2),
              non-transferable, non-sublicensable (except as expressly provided
              in this Section 6.2), revocable license to occupy the specific
              type of Property for only the specific period of time that you
              have reserved through our Service and for the maximum number of
              occupants permitted by us, as confirmed in writing by us and
              provided by us to you by email or other means (such specific type
              of property, the “Booked Property” and such specific period of
              time, the “Period of Occupancy”). For the avoidance of doubt, we
              are not obliged to make the Booked Property available, and a
              binding contract with respect to the Booked Property is not in
              place, until such time as you receive the foregoing written
              confirmation, and in no event shall you have any rights to
              renewal, extension, or recurring use of the Booked Property.
              Notwithstanding the foregoing: (a) you may sublicense the
              foregoing license to an employee, student, or third party for
              Limited Commercial Use only provided you meet the conditions set
              forth in Section 6.1(6.1.1)-(6.1.3)** need to check our stance
              with this; and (b) we reserve the right at all times during the
              Period of Occupancy to permit other individuals to enter the
              Booked Property at any time in the following circumstances or for
              the following purposes:
              <ol>
                <li>
                  in response to your written or verbal request, upon your
                  consent, or as necessary to provide the Service to you;
                </li>
                <li>
                  to investigate, address, or prevent any actual or reasonably
                  suspected or foreseeable past, current, or impending unlawful
                  activity;
                </li>
                <li>
                  to prevent or mitigate bodily harm to you or others that we
                  reasonably expect has occurred or may occur;
                </li>
                <li>
                  upon your breach of any provision of this Agreement, provided
                  that we give you prior notice (e.g., by email, phone, text
                  message, or knocking on the door);
                </li>
                <li>
                  for any purpose (including for repair and maintenance),
                  provided that we give you reasonable notice (e.g., by email,
                  phone, text message, or knocking on the door);
                </li>
                <li>
                  to cooperate with requests from law enforcement officials to
                  enter the Booked Property;
                </li>
                <li>
                  where we believe reasonably necessary to protect the personal
                  safety, rights, or property of us, you, any third party, or to
                  prevent fraud or other unlawful activity; and/or
                </li>
                <li>
                  at any time in the event of an emergency. You hereby agree to
                  direct any repair, maintenance and other operational
                  questions, requests, or complaints to Oasis Living and shall
                  not direct any such communications to Landlord.
                </li>
              </ol>
            </li>
            <li>
              Feedback License To Us. If you choose to provide suggestions or
              any other input regarding problems with, proposed modifications or
              improvements to, or any other aspect of the Service or Properties
              (“Feedback”), then you hereby grant us an unrestricted, worldwide,
              perpetual, irrevocable, non-exclusive, freely transferable and
              sublicensable (including through multiple tiers), royalty-free,
              and fully-paid right and license to exploit the Feedback in any
              manner and for any purpose with no obligation or accounting to
              you, including to improve the Service and Properties and create
              other products and services.
            </li>
          </ol>
        </li>
        <li>
          <strong>Restrictions and Responsibilities.</strong>
          <ol>
            <li>
              <strong>
                Compliance With Law. If you are prohibited under applicable law
                from using the Service or any of the Properties (including
                Booked Properties), you may not use them. You understand and
                agree that you are solely responsible for compliance with any
                and all laws, rules, and regulations that may apply to your use
                of the Service and/or Properties.
              </strong>
            </li>
            <li>
              <strong>Use of Amenities.</strong>You and your guest(s) may use
              only the Booked Property amenities (e.g., fitness room and gym
              equipment) that are described in your reservation confirmation.
              You agree to comply and ensure all of your guests’ compliance with
              all of our and the applicable Landlords’ rules with respect to
              your and your guests’ use of such amenities. You understand and
              agree that use of such amenities may be suspended if you or any of
              your guests violate any such rules. You shall be responsible for
              any damage to such amenities that you or any of your guests cause.
              ANY USE OF SUCH AMENITIES IS AT YOUR AND YOUR GUESTS’ OWN RISK AND
              YOU AND YOUR GUESTS RELEASE, DISCHARGE, AND COVENANT NOT TO SUE
              ANY OASIS LIVING ENTITIES IN CONNECTION WITH ANY USE OF SUCH
              AMENITIES.
            </li>
            <li>
              <strong>Prohibited Conduct.</strong>In connection with your use of
              the Service and Properties, you may not and you agree that you
              will not (except and solely to the extent such restriction is
              impermissible under applicable law):
              <ol>
                <li>
                  Use the Service or any Property for any illegal purpose or in
                  violation of any local, state, national, or international law
                  (e.g., you may not use your, our, or a third-party Internet
                  connection or device on any of our Properties to illegally
                  download or share files through BitTorrent, other peer-to-peer
                  protocols, or otherwise);
                </li>
                <li>
                  Impersonate any individual or organization, or falsify or
                  otherwise misrepresent yourself (including your age or date of
                  birth) or your affiliation with any individual or
                  organization;
                </li>
                <li>
                  Register for more than one Oasis Living account or register
                  for a Oasis Living account on behalf of an individual other
                  than yourself, except as expressly permitted under a
                  Commercial Agreement between you and us;
                </li>
                <li>
                  Use the Service or any Property for any commercial or other
                  purpose that is not expressly permitted under this Agreement
                  (for the avoidance of doubt, you may not resell or transfer to
                  any other individual or organization any reservation you make
                  through the Service, except as expressly permitted under a
                  Commercial Agreement between you and us), or make false,
                  fraudulent, or speculative reservations);
                </li>
                <li>
                  Reproduce, distribute, publicly display, or publicly perform
                  any aspect of the Service or make modifications to any aspect
                  of the Service or any Property;
                </li>
                <li>
                  Bring into or onto any Property any dangerous or hazardous
                  item (including items that are likely to increase the risk of
                  fire or explosion);
                </li>
                <li>
                  Attempt to decipher, decompile, disassemble, or reverse
                  engineer any of the software used to provide the Service;
                </li>
                <li>
                  Use, display, mirror, or frame any aspect of the Service
                  (including any layout or design of any webpage or form
                  contained therein), our name, or any of our trademarks, logos,
                  or other proprietary information, without our express written
                  consent;
                </li>
                <li>
                  Copy, store, or otherwise access any information accessible
                  through the Service or any Property for purposes not expressly
                  permitted under this Agreement;
                </li>
                <li>
                  Use manual or automated software, devices, scripts, robots, or
                  other means or processes to access, “scrape,” “crawl,” or
                  “spider” any web pages or other services contained in the
                  Service or to otherwise collect information or interact with
                  the Service;
                </li>
                <li>
                  Systematically retrieve data or other content from the Service
                  to create or compile, directly or indirectly, in one or more
                  downloads, a collection, compilation, database, directory, or
                  the like, whether by manual or automated methods;
                </li>
                <li>
                  Interfere or tamper with, circumvent, damage, or test the
                  vulnerability of any aspect of the Service or Properties
                  (including any physical item therein), whether by manual or
                  automated methods, including through the use of viruses,
                  cancel bots, Trojan horses, harmful code, flood pings,
                  denial-of-service attacks, packet or IP spoofing, forged
                  routing of email address information, or similar methods or
                  technology;
                </li>
                <li>
                  Infringe, misappropriate, or violate the rights of any
                  individual or organization, including their intellectual
                  property rights (including rights to trade secrets and moral
                  rights), or their privacy, publicity, confidentiality,
                  contractual, property, or other rights;
                </li>
                <li>
                  Use the Service or any Property to transmit, distribute, post,
                  or submit any information concerning any other individual or
                  organization without such individual’s or organization’s
                  permission, including photographs, personal contact
                  information, or credit, debit, calling card, or other account
                  numbers;
                </li>
                <li>
                  Engage in any conduct that:
                  <ol>
                    <li> would give rise to civil liability; </li>
                    <li>is fraudulent, false, misleading, or deceptive;</li>
                    <li>
                      is defamatory, obscene, pornographic, vulgar, or
                      offensive;
                    </li>
                    <li>
                      promotes or constitutes discrimination, bigotry, racism,
                      hatred, harassment, or harm against any individual or
                      group or otherwise threatens or embarrasses any individual
                      or group;
                    </li>
                    <li>
                      is violent or threatening or promotes violence or actions
                      that are threatening to any other individual or
                      organization;
                    </li>
                    <li>
                      promotes illegal or harmful activities or substances;
                      and/or
                    </li>
                  </ol>
                </li>
                <li>
                  Attempt to do any of the foregoing or assist or advocate,
                  encourage, permit, or assist any third party in doing any of
                  the foregoing.
                </li>
              </ol>
            </li>
            <li>
              <strong>Safety Features.</strong> You acknowledge and agree that
              the Properties may contain certain safety features such as smoke
              detectors or sound level monitoring units, you consent to our use
              of these safety features, and you agree not to interfere or tamper
              with these features (as prohibited under Section 7.3.12)
            </li>
            <li>
              <strong>Damaged Property. </strong>You are responsible for leaving
              any Booked Property in the condition it was in when you arrived
              and for following all related Additional Terms applicable toyour
              stay at a Booked Property. You acknowledge and agree that you are
              responsible for your own acts and omissions and are also
              responsible for the acts and omissions of any individuals who you
              invite to, or otherwise provide access to, any Booked Property. If
              we reasonably believe that you have damaged a Booked Property or
              damaged or stolen any physical item therein (“Damaged Property”),
              we will provide you with reasonable notice and evidence of such
              damage or suspected theft and will give you two business days to
              respond to our claim. After this time period, we will be
              automatically entitled to charge the Applicable Payment Method for
              the full amount of the greater of the costs and fees actually
              incurred by us or that we reasonably expect to incur for fixing or
              replacing the Damaged Property (which may include replacing
              damaged items with equivalent items) (“Damaged Property Fee”). We
              reserve at all times the right to fix the Damaged Property in the
              manner of our choosing and to pursue in our sole discretion any
              and all avenues available to us to collect from you the Damaged
              Property Fee. For example, we may exercise the foregoing right by
              fixing the Damaged Property over an extended period of time,
              charging the Applicable Payment Method the sum total of the
              Damaged Property Fee up front or in installments, or by making one
              or more claims under your homeowner’s, renter’s, and/or other
              insurance policy, and you agree to cooperate with and assist us in
              good faith, and to provide us with such information as we may
              reasonably request in order to successfully make such claim.
            </li>
            <li>
              <strong>Investigation and Prosecution.</strong>We reserve at all
              times the right to investigate and prosecute any breach of any
              provision of this Agreement to the fullest extent of the law. We
              may involve and cooperate with law enforcement authorities in
              prosecuting users who breach any provision of this Agreement. You
              acknowledge that we have no obligation to monitor your access to
              or use of the Service or Properties but have the right to do so
              for the purpose of operating the Service, to ensure your
              compliance with this Agreement, or to comply with applicable law
              or the order or requirement of a court, administrative agency, or
              other governmental body.
            </li>
          </ol>
        </li>
        <li>
          <strong>Ownership; Proprietary Rights.</strong>The Service is owned
          and operated by us. The visual interfaces, graphics, design,
          compilation, information, data, computer code (including source code
          or object code), products, software, services, and all other elements
          of the Service (<strong>“Materials”</strong>) provided by us are
          protected by intellectual property and other laws. All Materials
          included in the Service are our and/or our third-party licensors’
          property. Except as expressly authorized by us, you may not make use
          of the Materials. We reserve all rights to the Materials not granted
          expressly in this Agreement.
        </li>
        <li>
          <strong>Third-Party Terms.</strong>We may provide tools or features
          through the Service that enable you to interact with, including export
          information to, third-party websites or services, including through
          features that allow you to link your Oasis Living account with an
          account on a third-party website or service, such as Twitter,
          Facebook, or a third-party payment processor, or through our
          implementation of third-party buttons (such as “like” or “share”
          buttons). (* Can an individual register an account through signing
          into their social media account? SAM) By using one of these tools or
          features, you agree that we may transfer such exported information to
          the applicable third-party website or service. Third-party websites
          and services are not under our control, and, to the fullest extent
          permitted by law, we are not responsible for any third-party service’s
          use of your exported information. You acknowledge and agree that such
          interactions with third-party websites or services may be governed by
          one or more third parties’ terms, conditions, and/or policies.
        </li>
        <li>
          <strong>User Content</strong>
          <ol>
            <li>
              <stong>
                User Content Generally. Certain features of the Service may
                permit users to submit content to the Service, including
                messages, reviews, ratings, and other types of works (“User
                Content”)
              </stong>
              and to publish User Content on the Service. You retain any
              copyright and other proprietary rights that you may hold in the
              User Content that you post to the Service.
            </li>
            <li>
              <stong>
                Ratings and Reviews. Within a certain timeframe after completing
                a reservation, you and other users may provide us with a public
                review (“Review”) and/or rating (“Rating”)
              </stong>
              regarding your or such other user’s experience with the Service or
              at a Booked Property. Reviews and Ratings reflect the opinions of
              the individual or entity that leaves such Review or Rating, do not
              reflect our opinion, and may be incorrect or misleading. We may,
              but are not obliged to, verify any Reviews or Ratings for
              accuracy. You acknowledge and agree that if you provide a Review
              or Rating, such Review or Rating must be accurate, may not contain
              any offensive or defamatory language, may be surfaced anywhere
              (including publicly) on our Service or a third-party service as
              permitted by us, and constitute “User Content.”
            </li>
            <li>
              <stong>Limited License Grant to Us.</stong>By providing User
              Content to or via the Service, you grant us an unrestricted,
              worldwide, perpetual, irrevocable, non-exclusive, freely
              transferable and sublicensable (including through multiple tiers),
              royalty-free, and fully-paid right and license to exploit the User
              Content, in whole or in part, in any manner (including in any
              language or any media formats and through any media channels now
              known or hereafter developed) and for any purpose with no
              obligation or accounting to you.
            </li>
            <li>
              <stong>User Content Representations and Warranties.</stong>
              We disclaim any and all liability in connection with User Content.
              You are solely responsible for your User Content and the
              consequences of providing User Content via the Service. By
              providing User Content via the Service, you affirm, represent, and
              warrant that:
              <ol>
                <li>
                  you are the creator and owner of the User Content, or have the
                  necessary licenses, rights, consents, and permissions to
                  authorize us and our sublicensees to use and distribute your
                  User Content as necessary to exercise the licenses granted by
                  you in this Section 10, in the manner contemplated by us, the
                  Service, and this Agreement;
                </li>
                <li>
                  your User Content, and the use of your User Content as
                  contemplated by this Agreement, does not and will not:
                  <ol>
                    <li>
                      infringe, violate, or misappropriate any third party’s
                      right, including any copyright, trademark, patent, trade
                      secret, moral right, privacy right, right of publicity, or
                      any other intellectual property or proprietary right;
                    </li>
                    <li>
                      slander, defame, libel, or invade the right of privacy,
                      publicity, or other property rights of any other
                      individual or organization; or
                    </li>
                    <li>
                      cause us to violate any law, rule, or regulation; and
                    </li>
                  </ol>
                </li>
                <li>
                  your User Content could not be deemed by a reasonable person
                  to be objectionable, profane, indecent, pornographic,
                  harassing, threatening, embarrassing, hateful, or otherwise
                  inappropriate.
                </li>
              </ol>
            </li>
            <li>
              <stong>User Content Disclaimer.</stong>We are under no obligation
              to edit or control User Content that you or other users post or
              publish, and will not be in any way responsible or liable for User
              Content. We may, however, at any time and without prior notice,
              screen, remove, edit, or block any User Content that in our sole
              judgment violates this Agreement or is otherwise objectionable.
              You understand that when using the Service you may be exposed to
              User Content from a variety of sources and acknowledge that User
              Content may be inaccurate, offensive, indecent, or objectionable.
              You agree to waive, and do waive, any legal or equitable right or
              remedy you have or may have against us with respect to User
              Content. If notified by a user or content owner that User Content
              allegedly does not conform to this Agreement, we may investigate
              the allegation and determine in our sole discretion whether to
              remove the User Content, which we reserve the right to do at any
              time and without notice. For clarity, we do not permit
              copyright-infringing activities on the Service.
            </li>
            <li>
              <stong>Monitoring Content.</stong> We do not control and do not
              have any obligation to monitor:
              <ol>
                <li> User Content; </li>
                <li> any content made available by third parties; or </li>
                <li> the use of the</li>
              </ol>
              Service by its users. You acknowledge and agree that we reserve
              the right to, and may from time to time, monitor any and all
              information transmitted or received through the Service for
              operational and other purposes. If at any time we choose to
              monitor the content, we still assume no responsibility or
              liability for content or any loss or damage incurred as a result
              of the use of content.
            </li>
          </ol>
        </li>
        <li>
          <strong>Modification of this Agreement.</strong>We reserve the right
          to change this Agreement (including any of the Additional Terms) on a
          going-forward basis at any time. Please check this Agreement
          periodically for changes. If a change to this Agreement materially
          modifies your rights or obligations, we may require that you accept
          the modified Agreement in order to continue to use the Service or any
          Properties. Material modifications are effective upon your acceptance
          of the modified Agreement and we will provide you with reasonable
          notice prior to such changes taking effect. Please discontinue using
          the Service and any Property if you do not agree to these changes.
          Immaterial modifications are effective upon publication. Except as
          expressly permitted in this Section 11, this Agreement may be amended
          only by a written agreement signed by authorized representatives of
          the parties to this Agreement. Disputes arising under this Agreement
          will be resolved in accordance with the version of this Agreement that
          was in effect at the time the dispute arose.
        </li>
        <li>
          <strong>Term, Termination and Modification of the Service.</strong>
          <ol>
            <li>
              <strong>Term</strong>This Agreement is effective beginning when
              you accept it or first download, install, or otherwise access or
              use the Service or Properties, and its term ends when the
              Agreement is terminated as described in Section 13.2
            </li>
            <li>
              <strong>Termination</strong>To the maximum extent permitted by
              applicable law, if you violate any provision of this Agreement,
              all of our licenses to you and this Agreement automatically
              terminate without notice to you. In addition, we may, in our sole
              discretion, terminate this Agreement or your account on the
              Service, or suspend or terminate your access to the Service, at
              any time for any reason or no reason, with or without notice. You
              may terminate your account and this Agreement at any time by
              contacting customer service at{' '}
              <a href="mailto:info@oasis-living.org">info@oasis-living.org</a>{' '}
              and requesting that your account be deleted.
            </li>
            <li>
              <strong>Effect of Termination</strong>Upon termination of this
              Agreement:
              <ol>
                <li>
                  all of our licenses to you hereunder automatically terminate
                  and you must immediately cease all use of the Service and
                  Properties;
                </li>
                <li>
                  you will no longer be authorized to access your account or the
                  Service or any Properties;
                </li>
                <li>
                  you must pay us any unpaid amount that was due prior to
                  termination; and
                </li>
                <li>
                  all payment obligations accrued prior to termination and
                  Sections 5, 6.3, 7, 8, 10, 12.3, 13, 14, 15, 16, and 17 will
                  survive.
                </li>
              </ol>
            </li>
            <li>
              <strong>Modification of the Service. </strong>We reserve the right
              to modify or discontinue the Service at any time (including by
              limiting or discontinuing certain features of the Service such as
              any of our product or Property offerings), temporarily or
              permanently, without notice to you. We will have no liability for
              any change to the Service or any suspension or termination of your
              access to or use of the Service.
            </li>
          </ol>
        </li>
        <li>
          <strong>the Service.</strong>To the fullest extent permitted by law,
          you are responsible for your use of the Service and Properties, and
          you will defend and indemnify us and our officers, directors,
          employees, contractors, consultants, affiliates, subsidiaries,
          Landlords, and agents (individually a “Oasis Living Entity” and
          collectively the “Oasis Living Entities”) from and against every claim
          brought by a third party, and any related liability, direct or
          indirect damage, loss, and expense, including reasonable attorneys’
          fees and costs, arising out of or connected with: (a) your
          unauthorized use of, or misuse of, the Service or Properties; (b) your
          breach or violation of any portion of this Agreement, any
          representation, warranty, or agreement referenced in this Agreement,
          or any applicable law, rule, or regulation (including those put in
          place by Landlords from time to time); (c) your infringement,
          misappropriation, or violation of any third party’s right, including
          any intellectual property rights (including rights to trade secrets
          and moral rights), or any privacy, publicity, confidentiality,
          contractual, property, or other rights; (d) any dispute or issue
          between you and any third party; or (e) any injury, death, or damages
          sustained by any individual or entity, or to the property of the same,
          where such injury, death, or damage is caused by your or any of your
          guests’, visitors’, or invitees’ acts or omissions. We reserve the
          right, at our own expense, to assume the exclusive defense and control
          of any matter otherwise subject to indemnification by you (without
          limiting your indemnification obligations with respect to that
          matter), and in that case, you agree to cooperate with our defense of
          those claims.
        </li>
        <li>
          <strong>Disclaimers; No Warranties</strong>
          <ol>
            <li>
              <strong>
                THE SERVICE, PROPERTIES, AND ALL MATERIALS AND CONTENT AVAILABLE
                THROUGH THE SERVICE AND PROPERTIES ARE PROVIDED “AS IS” AND ON
                AN “AS AVAILABLE” BASIS. WE DISCLAIM ALL WARRANTIES OF ANY KIND,
                WHETHER EXPRESS OR IMPLIED, RELATING TO THE SERVICE, PROPERTIES,
                AND ALL MATERIALS AND CONTENT AVAILABLE THROUGH THE SERVICE AND
                PROPERTIES, INCLUDING: (A) ANY IMPLIED WARRANTY OF
                MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE, OR
                NON-INFRINGEMENT; AND (B) ANY WARRANTY ARISING OUT OF COURSE OF
                DEALING, USAGE,{' '}
              </strong>
              THE SERVICE AND PROPERTIES, INCLUDING: (A) ANY IMPLIED WARRANTY OF
              MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE, OR
              NON-INFRINGEMENT; AND (B) ANY WARRANTY ARISING OUT OF COURSE OF
              DEALING, USAGE, OR TRADE.
            </li>
            <li>
              <strong>
                WE DO NOT WARRANT THAT THE SERVICE, PROPERTIES, MATERIALS OR
                CONTENT AVAILABLE THROUGH THE SERVICE AND PROPERTIES, OR ANY
                PORTION OF ANY OF THE FOREGOING WILL BE UNINTERRUPTED, SECURE,
                OR FREE OF ERRORS, VIRUSES, OR OTHER HARMFUL{' '}
              </strong>
              COMPONENTS, AND WE DO NOT WARRANT THAT ANY OF THOSE ISSUES WILL BE
              CORRECTED.
            </li>
            <li>
              <strong>
                WE DO NOT MAKE ANY WARRANTY REGARDING THE QUALITY OF ANY ASPECT
                OF THE SERVICE, PROPERTIES, OR MATERIALS OR CONTENT AVAILABLE
                THROUGH THE SERVICE OR PROPERTIES,{' '}
              </strong>
              OR THE ACCURACY, TIMELINESS, TRUTHFULNESS, COMPLETENESS OR
              RELIABILITY OF THE FOREGOING.
            </li>
            <li>
              <strong>
                YOU UNDERSTAND AND AGREE THAT WE SHALL NOT BE RESPONSIBLE OR
                LIABLE FOR THE ACTIONS OF ANY THIRD PARTY OR ANY CONDITION OR
                CIRCUMSTANCE (E.G., CONSTRUCTION) OUTSIDE A PROPERTY.
              </strong>
            </li>
            <li>
              <strong>
                OTHER THAN AS SET OUT IN SECTION 15 BELOW, NO ADVICE OR
                INFORMATION, WHETHER ORAL OR WRITTEN, OBTAINED BY YOU FROM THE
                SERVICE, PROPERTIES, ANY MATERIALS OR CONTENT AVAILABLE THROUGH
                THE SERVICE OR PROPERTIES, OR ANY OASIS LIVING ENTITIES WILL
                CREATE ANY WARRANTY REGARDING ANY OF THE FOREGOING THAT IS NOT
                EXPRESSLY STATED IN THIS AGREEMENT.{' '}
              </strong>
              OTHER THAN AS SET OUT IN SECTION 15 BELOW, WE ARE NOT RESPONSIBLE
              FOR ANY DAMAGE THAT MAY RESULT FROM THE SERVICE, PROPERTIES, OR
              YOUR DEALING WITH ANY OTHER USER OF THE SAME. YOU UNDERSTAND AND
              AGREE THAT YOU USE ANY ASPECT OF THE SERVICE AND PROPERTIES AT
              YOUR OWN DISCRETION AND RISK, AND THAT WE ARE NOT RESPONSIBLE FOR
              ANY DAMAGE TO YOUR PROPERTY (INCLUDING YOUR COMPUTER SYSTEM,
              MOBILE DEVICE, OR ANY PHYSICAL BELONGINGS USED IN CONNECTION WITH
              YOUR USE OF THE SERVICE OR PROPERTIES) OR ANY LOSS OF DATA,
              INCLUDING USER CONTENT.
            </li>
            <li>
              WE DO NOT CONTROL ANY FEES THAT MAY BE CHARGED TO YOU BY ANY THIRD
              PARTY RELATING TO OUR COLLECTION OF ANY FEES THAT YOU OWE US UNDER
              THIS AGREEMENT, AND WE DISCLAIM ALL LIABILITY IN CONNECTION WITH
              THE FOREGOING.
            </li>
            <li>
              <strong>
                THE LIMITATIONS, EXCLUSIONS AND DISCLAIMERS IN THIS SECTION
                APPLY TO THE FULLEST EXTENT PERMITTED BY LAW. WE DO NOT DISCLAIM
                ANY WARRANTY OR OTHER RIGHT THAT WE ARE PROHIBITED FROM
                DISCLAIMING UNDER APPLICABLE LAW.
              </strong>
            </li>
            <li>
              “WE”, AS USED IN THIS SECTION 14, REFERS TO US AS WELL AS THE
              APPLICABLE LANDLORD(S).
            </li>
          </ol>
        </li>
        <li>
          <strong>Limitation of Liability</strong>
          <ol>
            <li>
              TO THE FULLEST EXTENT PERMITTED BY LAW, IN NO EVENT WILL ANY
              ENTITY BE LIABLE TO YOU FOR ANY INDIRECT, INCIDENTAL, SPECIAL,
              CONSEQUENTIAL OR PUNITIVE DAMAGES, INCLUDING DAMAGES FOR LOSS OF
              PROFITS, REPUTATION, GOODWILL, INCOME, SALES, REVENUE, BUSINESS,
              ANTICIPATED SAVINGS, OR DATA, OR FOR BUSINESS INTERRUPTION, WASTED
              MANAGEMENT OR OFFICE TIME, OR ANY OTHER INTANGIBLE LOSS.{' '}
            </li>
            <li>
              TO THE FULLEST EXTENT PERMITTED BY LAW, IN NO EVENT WILL ANY OASIS
              LIVING ENTITY BE LIABLE TO YOU FOR ANY DAMAGES FOR PERSONAL OR
              BODILY INJURY OR EMOTIONAL DISTRESS, ARISING OUT OF OR RELATING TO
              YOUR ACCESS TO OR USE OF, OR YOUR INABILITY TO ACCESS OR USE, THE
              SERVICE, PROPERTIES, OR ANY MATERIALS OR CONTENT AVAILABLE THROUGH
              THE SERVICE OR PROPERTIES, WHETHER BASED ON WARRANTY, CONTRACT,
              TORT (INCLUDING NEGLIGENCE), STATUTE, OR ANY OTHER LEGAL THEORY,
              AND WHETHER OR NOT ANY OASIS LIVING ENTITY HAS BEEN INFORMED OF
              THE POSSIBILITY OF DAMAGE.
            </li>
            <li>
              WE DO NOT EXCLUDE OR LIMIT IN ANY WAY OUR LIABILITY TO YOU WHERE
              IT WOULD BE UNLAWFUL TO DO SO. IN THE UK AND THE EU, THIS INCLUDES
              LIABILITY: FOR DEATH OR PERSONAL INJURY CAUSED BY OUR NEGLIGENCE
              OR THE NEGLIGENCE OF OUR EMPLOYEES, AGENTS, OR SUBCONTRACTORS; FOR
              FRAUD OR FRAUDULENT MISREPRESENTATION; OR FOR BREACH OF OUR
              OBLIGATION TO PERFORM THE SERVICE WITH REASONABLE CARE AND SKILL
              OR FAILURE TO PERFORM THE SERVICE IN ACCORDANCE WITH INFORMATION
              PROVIDED BY US TO YOU ABOUT US OR THE SERVICE.
            </li>
            <li>
              <strong>
                EXCEPT AS PROVIDED IN SECTION 15.5 AND TO THE FULLEST EXTENT
                PERMITTED BY LAW, THE AGGREGATE LIABILITY OF THE OASIS LIVING
                ENTITIES TO YOU FOR ALL CLAIMS ARISING OUT OF OR RELATING TO
                THIS AGREEMENT OR TO THE USE OF OR ANY INABILITY TO USE ANY
                PORTION OF THE SERVICE, PROPERTIES, OR ANY MATERIALS OR CONTENT
                AVAILABLE THROUGH THE SERVICE OR PROPERTIES, WHETHER IN
                CONTRACT, TORT, OR OTHERWISE, IS LIMITED TO THE GREATER OF: (A)
                THE AMOUNT YOU HAVE PAID TO US
              </strong>
              FOR ACCESS TO AND USE OF THE SERVICE AND PROPERTIES IN THE 12
              MONTHS PRIOR TO THE EVENT OR CIRCUMSTANCE GIVING RISE TO CLAIM; OR
              (B) $100; UNLESS THE UK HOTEL PROPRIETORS’ ACT 1956 APPLIES, IN
              WHICH CASE OUR LIABILITY WILL BE LIMITED TO THE MAXIMUM PRESCRIBED
              UNDER THAT ACT.
            </li>
            <li>
              EACH PROVISION OF THIS AGREEMENT THAT PROVIDES FOR A LIMITATION OF
              LIABILITY, DISCLAIMER OF WARRANTIES, OR EXCLUSION OF DAMAGES IS
              INTENDED TO AND DOES ALLOCATE THE RISKS BETWEEN THE PARTIES UNDER
              THIS AGREEMENT. THIS ALLOCATION IS AN ESSENTIAL ELEMENT OF THE
              BASIS OF THE BARGAIN BETWEEN THE PARTIES. EACH OF THESE PROVISIONS
              IS SEVERABLE AND INDEPENDENT OF ALL OTHER PROVISIONS OF THIS
              AGREEMENT. THE LIMITATIONS IN THIS SECTION 16 WILL APPLY EVEN IF
              ANY LIMITED REMEDY FAILS OF ITS ESSENTIAL PURPOSE.{' '}
            </li>
          </ol>
        </li>
        <li>
          <strong>COMPLAINTS</strong>
          If you are dissatisfied with our service and you are unable to resolve
          such dissatisfaction with your Oasis Living contact, you should email{' '}
          <a href="mailto:info@oasis-living.org">info@oasis-living.org</a>. Your
          complaint will be acknowledged within 3 working days of receipt and an
          investigation undertaken. A formal written response will be sent to
          you within 15 working days of receipt of your formal complaint. If you
          remain dissatisfied, you may be entitled to refer the matter to The
          Property Ombudsman (TPO) within six months for a review.- CLARIFY
        </li>
        <li>
          <strong>Miscellaneous</strong>This Agreement, together with the
          Privacy Policy (if applicable) and any other agreements expressly
          incorporated by reference into this Agreement, is the entire and
          exclusive understanding and agreement between you and Oasis Living
          regarding your use of the Service and Properties, and supersedes any
          previous marketing information, representations or agreements of any
          kind or nature between the parties relating to the subject matter
          hereof and whether recorded in writing, or otherwise. You may not
          assign or transfer this Agreement or your rights under this Agreement,
          in whole or in part, by operation of law or otherwise, without our
          prior written consent, which may be withheld if, for example, we
          reasonably determine that the potential assignee or transferee is, or
          is likely to be, a competitor of us, or appears unwilling to or
          incapable of strictly complying with this Agreement. We may assign or
          transfer this Agreement, in whole or in part, at any time without
          notice or consent. The failure to require performance of any provision
          of this Agreement will not affect our right to require performance at
          any other time after that, nor will a waiver by us of any breach or
          default of this Agreement, or any provision of this Agreement, be a
          waiver of any subsequent breach or default or a waiver of the
          provision itself. Use of section headers in this Agreement is for
          convenience only and will not have any impact on the interpretation of
          any provision. Nothing in this Agreement will affect your statutory
          rights as a consumer. Throughout this Agreement the use of the word
          “including” means “including but not limited to”. If any part of this
          Agreement is held to be invalid or unenforceable, the unenforceable
          part will be given effect to the greatest extent possible, and the
          remaining parts will remain in full force and effect.
        </li>
      </ol>
    </>
  );
};

export default TermsAndConditionsContent;
